import { useState } from 'react'
import { changeOperation, autoChangeOperation, getAgencyInfoList, getAccountInfo } from '../utils/network'
import { cgiCallWrapper } from 'utils/cgiCallWrapper'
import showAlert from 'utils/showAlert'
import { searchAMS } from 'utils/searchAMSInfo'
import { ACCOUNT_TYPE } from '../../OperationList/constants'
const initialSubmitInfo = {
    uid: '',
    serviceProviderId: '',
    selectAccount: 0,
    showInput: false,
}
const useOperationAdd = props => {
    const { appInfo, onClose, updateList, adType } = props
    const [submitInfo, setSubmitInfo] = useState(initialSubmitInfo)
    const [error, setError] = useState('')
    const [disableSubmit, setDisableSubmit] = useState(false)

    const reset = () => {
        setSubmitInfo(initialSubmitInfo)
    }

    const validateCheck = () => {
        if (!submitInfo.selectAccount) {
            return '请选择投放账户类型'
        }
        if (
            submitInfo.selectAccount &&
            Number(submitInfo.selectAccount) === ACCOUNT_TYPE.SERVICE_PROVIDER &&
            submitInfo.serviceProviderId === ''
        ) {
            return '请输入服务商ID'
        }
        if (submitInfo.serviceProviderId !== '' && !/^\d+$/.test(`${submitInfo.serviceProviderId}`)) {
            return '服务商ID必须为纯数字'
        }
        if (!submitInfo.uid) {
            return '请填写账户ID'
        }
        if (!/^\d+$/.test(`${submitInfo.uid}`)) {
            return '账户ID格式必须为纯数字'
        }
        return ''
    }
    const setServiceProviderId = val => {
        setSubmitInfo({
            ...submitInfo,
            serviceProviderId: val,
        })
    }
    const setAccount = val => {
        setSubmitInfo({
            ...submitInfo,
            selectAccount: val,
            showInput: val === 1,
        })
    }
    const setUid = val => {
        setSubmitInfo({
            ...submitInfo,
            uid: val,
        })
    }

    const validateForm = () => {
        const errorMsg = validateCheck()
        setError(errorMsg)
        if (errorMsg) return false
        return true
    }

    const getUidInfo = async () => {
        try {
            let uids = {}
            // 投放帐户类型——服务商
            if (submitInfo.selectAccount === ACCOUNT_TYPE.SERVICE_PROVIDER) {
                setDisableSubmit(true)
                const serviceInfo = await searchAMS({
                    serviceProviderId: submitInfo.serviceProviderId,
                    getAccountInfo: getAccountInfo,
                })
                if (!serviceInfo) {
                    setDisableSubmit(false)
                    return
                }
                // 子客信息
                const agencyRes = await cgiCallWrapper(
                    getAgencyInfoList,
                    {
                        agency_id: submitInfo.serviceProviderId,
                        account_ids: submitInfo.uid.split(','),
                        account_type: 1,
                        advertiser_type: 2,
                        size: 200,
                    },
                    false
                )
                setDisableSubmit(false)
                if (agencyRes.code === 0) {
                    const agencyList = agencyRes.data.list.map(item => {
                        return {
                            uid: String(item.account_id),
                            uidName: item.nick_name,
                            uidCategory: item.attribution_department || '',
                            serviceInfo,
                        }
                    })
                    if (agencyList.length === 0) {
                        showAlert('error', '该服务商下没有子客')
                        setDisableSubmit(false)
                        return
                    }
                    const accountUids = agencyList.length > 0 ? agencyList.map(item => Number(item.uid)) : []
                    const newIds = submitInfo.uid.split(',')
                    const oldIds = []
                    newIds.forEach(id => {
                        if (Number(id) !== 0 && !accountUids.includes(Number(id))) {
                            oldIds.push(id)
                        } else {
                            uids = agencyList.find(v => Number(v.uid) === Number(id))
                        }
                    })
                    if (oldIds.length > 0) {
                        showAlert('error', `投入账户ID:${oldIds.join(',')},不在服务商${serviceInfo.serviceID}名下`)
                        setDisableSubmit(false)
                        return
                    }
                }
                if (agencyRes.code !== 0) {
                    showAlert('error', '程序错误，请联系客服')
                    setDisableSubmit(false)
                    return
                }
            }

            // 投放帐户类型——直客
            if (submitInfo.selectAccount === ACCOUNT_TYPE.DIRECT) {
                setDisableSubmit(true)
                // 得到服务商信息
                const agencyRes = await cgiCallWrapper(
                    getAgencyInfoList,
                    {
                        account_ids: submitInfo.uid.split(','),
                        size: 200,
                        account_type: 1,
                        advertiser_type: 1,
                    },
                    false
                )
                setDisableSubmit(false)
                if (agencyRes.code === 0) {
                    if (agencyRes.data.list.length > 0) {
                        const agencyList = agencyRes.data.list.map(item => {
                            return {
                                uid: String(item.account_id),
                                uidName: item.nick_name,
                                uidCategory: item.attribution_department || '',
                            }
                        })
                        const accountUids = agencyList.length > 0 ? agencyList.map(item => Number(item.uid)) : []
                        const oldIds = []
                        submitInfo.uid.split(',').forEach(id => {
                            if (Number(id) !== 0 && !accountUids.includes(Number(id))) {
                                oldIds.push(id)
                            } else {
                                uids = agencyList.find(v => Number(v.uid) === Number(id))
                            }
                        })
                        if (oldIds.length > 0) {
                            showAlert('error', `${oldIds.join(',')}子客不存在`)
                            setDisableSubmit(false)
                            return
                        }
                    }
                    if (agencyRes.data.list.length < 1) {
                        showAlert('error', '直客投放帐户下不存在该帐户id')
                        setDisableSubmit(false)
                        return
                    }
                }
                if (agencyRes.code !== 0) {
                    showAlert('error', '程序错误，请联系客服')
                    setDisableSubmit(false)
                    return
                }
            }
            return uids
        } catch (_) {
            showAlert('error', '程序错误，请联系客服')
            setDisableSubmit(false)
            return
        }
    }
    const handleSubmit = async e => {
        e.preventDefault()
        try {
            if (!validateForm()) return
            const newUidInfo = await getUidInfo()
            if (!newUidInfo) return

            setDisableSubmit(true)
            // 如果类型=2时，走自动审核
            const res = await cgiCallWrapper(adType === 2 ? autoChangeOperation : changeOperation, {
                adType,
                oldUid: props.uidInfo.uid,
                appid: appInfo.appId,
                newUidInfo,
            })
            setDisableSubmit(false)
            if (res.c !== 200) return
            showAlert('success', '换绑申请提交成功')
            onClose()
            updateList() // 更新列表数据
            reset()
        } catch (_) {
            showAlert('error', '程序错误，请联系客服')
            setDisableSubmit(false)
        }
    }
    return {
        handleSubmit,
        disableSubmit,
        setDisableSubmit,
        setAccount,
        setServiceProviderId,
        submitInfo,
        setSubmitInfo,
        setUid,
        reset,
        error,
    }
}

export default useOperationAdd
